// pages/treach/sections/LogsSection.jsx
import React from "react";

const LogsSection = () => {
  return (
    <div className="text-gray-200 text-sm">
      <p>📜 <strong>Activity Logs</strong></p>
      <ul className="list-disc list-inside mt-3 text-gray-400">
        <li>10:15 – Campaign created</li>
        <li>14:30 – Creatives uploaded</li>
        <li>09:00 – Media plan approved</li>
      </ul>
    </div>
  );
};

export default LogsSection;
